module.exports = __webpack_public_path__ + "static/img/he_fei.1992c7c7.png";